<template>
  <div>
    <div v-popover:popover3 class="outLogin">
      <img src="static/images/icon/top_01.png" />
      <span>换肤</span>
      <i class="el-icon-arrow-right"></i>
    </div>
    <el-popover ref="popover3" placement="left-start" popper-class="offset_25" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
      <div class="themeList">
        <div v-for="n in 6" :key="n" :class="'li'+' bg_'+n" @click="changeColor(n)">
          <p v-if="themeNum == n"></p>
          <div v-if="themeNum == n" class="span">√</div>
        </div>
      </div>
    </el-popover>
  </div>
  <!-- <span>
        <el-popover ref="popover3" placement="bottom-end" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
            <div class="themeList">
                <div v-for="n in 6" :key="n" :class="'li'+' bg_'+n" @click="changeColor(n)">
                    <p v-if="themeNum == n"></p>
                    <div v-if="themeNum == n" class="span">√</div>
                </div>
            </div>
        </el-popover>
        <img class="printer" style="margin: 9px 10px;" v-popover:popover3 src="static/images/icon/top_01.png" />
    </span> -->
</template>
<script>
import { getStyleIndex, saveStyleIndex } from './api/index';

export default {
  data() {
    return {
      themeNum: '', // 选择的主题颜色值
      uaValue: '', // 判断是手机端还是PC端   pc为PC端，mobile为手机端
    };
  },
  created() {
    this.uaValue = this.Lib.pcOrMobile();
    if (window.location.href.indexOf('http://gg.deeptel.com.cn') > -1) {
      require('./style/colorLocal.less');
    } else {
      require('./style/color.less');
    }
    getStyleIndex({}).then((res) => {
      if (res.code == 0) {
        this.themeNum = res.data ? res.data.styleIndex ? res.data.styleIndex : 1 : 1;
        document.getElementById('indexTheme').className = `theme${this.themeNum}`;
      } else {
        // console.log(res)
      }
    });
  },
  methods: {
    // 把className的主题挂载在index.html的<body id="indexTheme"></body>上
    changeColor(num) {
      const data = {
        styleIndex: num
      };
      saveStyleIndex(data).then((res) => {
        if (res.code == 0) {
          this.themeNum = num;
          document.getElementById('indexTheme').className = `theme${num}`;
        } else {
          // console.log(res)
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.themeList {
    float: left;
    padding: 15px 20px;
    .li {
        width: 70px;
        height: 70px;
        background-blend-mode: normal, normal;
        float: left;
        margin-right: 10px;
        cursor: pointer;
        p {
            margin-top: 45px;
            width: 65px;
            height: 25px;
            line-height: 25px;
            font-size: 12px;
            padding-left: 5px;
            background-color: rgba(0, 0, 0, 0);
            color: #fff;
        }
        .span {
            width: 21px;
            height: 21px;
            text-align: center;
            color: #fff;
            border: solid 2px #ffffff;
            border-radius: 50%;
            position: absolute;
            margin-left: 51px;
            margin-top: -23px;
        }
    }
    .li:nth-child(1) .span {
        background-color: #fd5c8c;
    }
    .li:nth-child(2) .span {
        background-color: #ffc85f;
    }
    .li:nth-child(3) .span {
        background-color: #09d8fd;
    }
    .li:nth-child(4) .span {
        background-color: #e270f5;
    }
    .li:nth-child(5) .span {
        background-color: #ff822f;
    }
    .li:nth-child(6) .span {
        background-color: #333333;
    }
    .li:last-child {
        margin-right: 0;
    }
    .bg_1 {
        background-image: linear-gradient(0deg, #f52e69 0%, #fd5c8c 100%),
            linear-gradient(#fd5c8c, #fd5c8c);
    }
    .bg_2 {
        background-image: linear-gradient(
                0deg,
                #ff9c48 0%,
                #ffad42 100%,
                #ffbc51 100%,
                #ffca60 100%
            ),
            linear-gradient(#fd5c8c, #fd5c8c);
    }
    .bg_3 {
        background-image: linear-gradient(0deg, #5966fa 0%, #06dcfe 100%),
            linear-gradient(#fd5c8c, #fd5c8c);
    }
    .bg_4 {
        background-image: linear-gradient(0deg, #bb31d1 0%, #e472f6 100%),
            linear-gradient(#fd5c8c, #fd5c8c);
    }
    .bg_5 {
        background-image: linear-gradient(0deg, #ff5e55 0%, #ff832d 100%),
            linear-gradient(#fd5c8c, #fd5c8c);
    }
    .bg_6 {
        background-image: linear-gradient(0deg, #333333 0%, #555555 100%),
            linear-gradient(#fd5c8c, #fd5c8c);
    }
}
.printer {
    width: 22px;
    height: 22px;
    margin: 14px 10px;
    float: left;
    cursor: pointer;
}
.outLogin {
    padding: 15px 0;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    color: #999;
    cursor: pointer;
    border-bottom: 1px solid #f5f5f5;
    img {
        width: 16px;
        height: 16px;
        position: absolute;
        margin: 7px 0 0 3px;
    }
    span {
        padding-left: 30px;
    }
    i {
        float: right;
        height: 30px;
        line-height: 30px;
        padding-left: 10px;
    }
}
</style>
